import { render, staticRenderFns } from "./TechnicalValues.vue?vue&type=template&id=09bbe6d5&"
import script from "./TechnicalValues.vue?vue&type=script&lang=js&"
export * from "./TechnicalValues.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports